import React from "react";
import { StandardPageWrapper } from "../../components/layout/StandardPageWrapper";
import { PageHeader } from "../../components/layout/header/Header";
import { DeveloperSetupShareCard } from "../../components/privacyCenter/DeveloperSetupShareCard";
import {
  DomainSetupCard,
  DomainSetupProgress,
} from "../../components/superorg/settings/DomainSetupCard";
import { usePrimaryOrganization } from "../../hooks";
import { SettingsTabs } from "./SettingsTabs";

export const OrganizationDomainSettingsPage = () => {
  const [organization] = usePrimaryOrganization();
  const [hasSavedDomain, setHasSavedDomain] = React.useState(false);
  const handleDomainStateChange = React.useCallback(
    ({ hasSavedDomain: nextHasSavedDomain }: DomainSetupProgress) => {
      setHasSavedDomain(nextHasSavedDomain);
    },
    [],
  );
  return (
    <StandardPageWrapper>
      <div className="max-width-896">
        <PageHeader titleContent="Account Settings" marginBottomPx={0} />
        <SettingsTabs current="domain" />
        <div className="tw-boundary mt-lg">
          <DomainSetupCard
            className="w-full"
            hideCardChrome={true}
            onStateChange={handleDomainStateChange}
          />
          {hasSavedDomain && (
            <DeveloperSetupShareCard devInstructionsId={organization?.devInstructionsId} />
          )}
        </div>
      </div>
    </StandardPageWrapper>
  );
};
